import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatRupiah, formatErr } from "../lib/api";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { ArrowLeft, Clock, ListChecks, Lock, Sparkles, Play } from "lucide-react";
import { toast } from "sonner";

export default function TestDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { addItem } = useCart();
  const [t, setT] = useState(null);

  useEffect(() => {
    api.get(`/tests/${slug}`).then(r => setT(r.data)).catch(() => navigate("/tests"));
  }, [slug, navigate]);

  if (!t) return <div className="lumina-container py-20 text-center text-[#5C5870]">Memuat…</div>;

  const startFree = () => {
    if (!user) {
      toast.info("Login dulu untuk memulai tes");
      navigate("/login", { state: { from: { pathname: `/tests/${slug}` } } });
      return;
    }
    navigate(`/tests/${slug}/take`);
  };

  const buyAccess = () => {
    if (!user) {
      navigate("/login", { state: { from: { pathname: `/tests/${slug}` } } });
      return;
    }
    addItem({ item_type: "test", item_id: t.id, title: t.title, price: t.price, image: t.image });
    toast.success("Tes ditambahkan ke keranjang");
    navigate("/checkout");
  };

  const tryStart = async () => {
    // For paid test, check if already purchased — try to call /start
    try {
      await api.get(`/tests/${slug}/start`);
      navigate(`/tests/${slug}/take`);
    } catch (err) {
      if (err.response?.status === 403) buyAccess();
      else toast.error(formatErr(err.response?.data?.detail));
    }
  };

  return (
    <div className="lumina-container py-12" data-testid="test-detail-page">
      <Link to="/tests" className="inline-flex items-center gap-2 text-[#5C5870] hover:text-[#6B4BA3] mb-8 text-sm"><ArrowLeft className="w-4 h-4" /> Kembali</Link>
      <div className="grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-3">
          <div className="lumina-card overflow-hidden mb-8">
            <img src={t.image} alt={t.title} className="w-full aspect-[16/10] object-cover" />
          </div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E8F0FA] text-xs font-medium text-[#6B4BA3] mb-4">
            {t.price === 0 ? <Sparkles className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
            {t.price === 0 ? "GRATIS" : "PREMIUM"}
          </div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1728] mb-4 leading-tight">{t.title}</h1>
          <p className="text-[#5C5870] mb-2"><strong>Target peserta:</strong> {t.target_audience}</p>
          <p className="text-[#5C5870] leading-relaxed text-lg mt-6">{t.long_description || t.description}</p>
        </div>
        <div className="lg:col-span-2">
          <div className="lumina-card p-7 sticky top-28">
            <div className="text-[#6B4BA3] font-semibold text-3xl mb-6">{t.price === 0 ? "Gratis" : formatRupiah(t.price)}</div>
            <div className="space-y-4 mb-6 text-sm">
              <div className="flex items-center gap-3"><Clock className="w-4 h-4 text-[#6B4BA3]" /> <span>Durasi: {t.duration_minutes} menit</span></div>
              <div className="flex items-center gap-3"><ListChecks className="w-4 h-4 text-[#6B4BA3]" /> <span>{t.question_count} pertanyaan</span></div>
            </div>
            {t.price === 0 ? (
              <button onClick={startFree} className="lumina-btn-primary w-full" data-testid="start-test-btn"><Play className="w-4 h-4" /> Mulai Tes Gratis</button>
            ) : (
              <button onClick={tryStart} className="lumina-btn-primary w-full" data-testid="buy-test-btn"><Lock className="w-4 h-4" /> Beli & Mulai Tes</button>
            )}
            <p className="text-xs text-[#5C5870] text-center mt-3">Hasil instant setelah submit</p>
          </div>
        </div>
      </div>
    </div>
  );
}
